import React from "react";
import Navbar from "./components/navbar/Navbar";
import { useTranslation } from 'react-i18next';
const App = () => {
     const { i18n } = useTranslation();
    document.body.dir = i18n.dir();
  return (
    <React.StrictMode>
      <Navbar />
    </React.StrictMode>
  );
};

export default App;
